import Img1 from "assets/png/security.png";
import Img2 from "assets/png/authenticate.png";
import Img3 from "assets/png/secure.png";

const Services = () => {
  const data = [
    {
      img: Img1,
      title: "Noble Guard Security",
      text: "We offer professional security services, including on-site security personnel, surveillance systems, and risk assessment strategies to ensure the safety of people and assets.",
      path: "https://security.nobleguard.com.ng/",
      btn: "Get a security assessment",
    },
    {
      img: Img2,
      title: "Authenticate with Noble Guard",
      text: "Ensure security with advanced authentication technologies and biometric verification, providing thorough background checks for employees, and individuals to prevent fraud and ensure compliance.",
      path: "https://authenticate.nobleguard.com.ng/",
      btn: "Contact us",
    },
    {
      img: Img3,
      title: "Noble Secure Technologies",
      text: "From cloud security to enterprise-level infrastructure, we provide modern technology solutions that safeguard your digital assets and streamline your IT operations.",
      path: "https://technologies.nobleguard.com.ng/",
      btn: "Request a quote",
    },
  ];

  return (
    <div
      className="w-full py-12 lg:py-20 px-8 lg:px-20 bg-blue-100 flex flex-col items-center gap-10"
      id="services"
    >
      <div className="flex flex-col gap-4 items-center">
        <p className="text-3xl font-bold text-white">Our Arms</p>

        <p className="max-w-[550px] text-lg text-gray-100 font-medium text-center">
          Explore our divisions and find the right solution for you
        </p>
      </div>

      <div className="w-full grid grid-cols-1 lg:grid-cols-3 gap-10">
        {data.map((item) => (
          <div
            className="w-full border border-white rounded-2xl p-4 flex flex-col gap-8"
            key={item.title}
          >
            <img
              src={item.img}
              alt={item.title}
              className="h-[250px] object-cover"
            />

            <div className="space-y-2">
              <p className="text-white font-bold lg:text-xl">{item.title}</p>

              <p className="text-sm lg:text-base text-white">{item.text}</p>
            </div>

            <a
              href={item.path}
              target="_blank"
              rel="noreferrer"
              className="w-full py-4 bg-gray-200 text-blue-100 rounded-2xl font-medium text-center"
            >
              {item.btn}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
